module.exports = __webpack_public_path__ + "static/media/hall-P9.ac8a611a.svg";